import { Component, Input } from '@angular/core';

@Component({
  selector: '[app-tr-parts-category]',
  template: `
  <td class="align-middle ">{{category?.name}}</td>
  <td class="align-middle ">{{category?.description}}</td>
  <td class="align-middle text-center">{{category?.subcategories}}</td>
  <td class="align-middle text-center">{{category?.structural}}</td>
  <td class="align-middle text-center">{{category?.part_count}}</td>
  `,
  styleUrls: []
})
export class TrPartsCategoryComponent {
  @Input() category: any;
  @Input() profile: any;
  @Input() permissions: any;
}
